import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { BackpackIconsModule } from '../../backpack-icons/backpack-icons.module';

@Component({
	selector: 'sp-upload-student-list',
	template: `
		<div class="tw-p-2 tw-cursor-pointer hover:tw-bg-gray-050 wrapper" (mousedown)="handleClick.emit()">
			<div class="tw-flex tw-gap-2 tw-items-center">
				<div
					class="tw-flex tw-w-[28px] tw-h-[28px] tw-box-border tw-items-center tw-justify-center tw-padding-[10px] tw-rounded-lg tw-bg-gray-100 tw-text-gray-500 ">
					<bp-icon [icon]="'upload'"></bp-icon>
				</div>
				<div class="tw-text-navy-500 tw-text-[15px] tw-font-semibold">Upload a list of students</div>
			</div>
		</div>
	`,
	styles: [
		`
			.wrapper {
				border-radius: 10px;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [BackpackIconsModule],
})
export class UploadStudentListComponent {
	@Output() handleClick: EventEmitter<void> = new EventEmitter<void>();
}
